<template>
 

      <nav class="navbar" style="position: absolute;margin:-62px 0 0 0px;z-index: 9999;">
          <button class="navbar-toggler" 
          type="button" 
          data-bs-toggle="offcanvas" 
          data-bs-target="#offcanvasNavbar" 
          aria-controls="offcanvasNavbar" 
          aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
          </button>

          <div class="offcanvas offcanvas-start" tabindex="0" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
              <div class="offcanvas-header">
                  <h5 class="offcanvas-title" id="offcanvasNavbarLabel">{{ $t("system.menutitle") }} </h5>
                  <button type="button" ref="menu-btn-close" class="btn-close btn-close-black" data-bs-dismiss="offcanvas" aria-label="Close"></button>
              </div>
              
              <div class="accordion" id="accordionExample">
                 
                  <!--   第一個選單    -->
                  <div class="accordion-item"   v-if="is_Sourcer || is_Supervisor">                      
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">{{ $t("accountCreate.title") }}</button>                      
                      <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body  navbar-nav">  
                                <ul style="text-align: left;">
                                     
                                    <li v-if="is_Sourcer">
                                        <router-link :to="'/sourcerNewApplyType1'"   @click="routerlinkClickHandler">{{ $t("accountCreate.SupervisorAccount") }}</router-link>
                                    </li>
                                    <li v-if="is_Sourcer">
                                        <router-link :to="'/sourcerApplyList'"  @click="routerlinkClickHandler">{{ $t("accountCreate.SourcerApplyList") }}</router-link>
                                    </li>
                                    <li v-if="is_Sourcer">
                                        <router-link :to="'/sourcerSupervisorList'"  @click="routerlinkClickHandler" >{{ $t("accountCreate.SourcerSupervisorList") }}  </router-link>
                                    </li>
                                    
                                      


                                    <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorUpdateInformation'"   @click="routerlinkClickHandler">{{ $t("accountCreate.SupervisorInformation") }}</router-link>
                                    </li>
                                    <li v-if="is_Supervisor">
                                        <router-link :to="'/SupervisorNewApplyType2'"   @click="routerlinkClickHandler">{{ $t("accountCreate.userAccount") }}</router-link>
                                    </li>
                                    <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorApplyList'"   @click="routerlinkClickHandler">{{ $t("accountCreate.SupervisorApplyList") }}</router-link>
                                    </li>
                                </ul>                              
                          </div>
                      </div>
                    </div>
                  
                  <!--   第二個選單    -->
                  <div class="accordion-item"  v-if="is_CompalUser">                      
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">{{ $t("pendingApproval.title") }}</button>
                      
                      <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">
                              <ul style="text-align: left;">
                                      <li>
                                        <router-link :to="'/flowList'"   @click="routerlinkClickHandler">{{ $t("pendingApproval.pendingApproval") }}
                                          <Badge :value="flowCount"></Badge></router-link> 
                                        
                                       </li>
                                  </ul>    
                          </div>
                      </div>
                  </div>
                   <!--   第8個選單   -->
                
                   <div class="accordion-item"   v-if="is_SCSI || is_Sourcer"> <!---accordion-item-------->                    
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse8" aria-expanded="false" aria-controls="collapse8">
                            {{ $t("deleteLogReport.title") }}
                          </button>
                      
                      <div id="collapse8" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">
                                    <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_Supervisor_DeleteMFGVendorCode'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.supervisor_DeleteMFGVendorCode") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_Supervisor_DeleteSystem'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.supervisor_DeleteSystem") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_Supervisor_DeleteUser'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.supervisor_DeleteUser") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_SCSI_ChangeSourcer'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.scsi_ChangeSourcer") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_SCSI_DeleteSearchTerm'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.scsi_DeleteSearchTerm") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/DeleteLogReport_SCSI_DeleteSupervisor'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.scsi_DeleteSupervisor") }}</router-link> 
                                      </li>
                                      <li  v-if="is_SCSI || is_Sourcer">
                                        <router-link :to="'/DeleteLogReport_Sourcer_CancelMFGCode'"  @click="routerlinkClickHandler" >{{ $t("deleteLogReport.sourcer_CancelMFGCode") }}</router-link> 
                                      </li>
                                   </ul>                              
                          </div>
                      </div>
                  </div><!---accordion-item--------> 
                  <!--------------------------------------->
                  <!--   第三個選單   -->
                  <div class="accordion-item"   v-if="is_Sourcer || is_SCSI || is_Supervisor">                     
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                            {{ $t("permissionSetting.title") }}
                          </button>
                      <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">
                                      <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorApplyType4'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.addSupervisorPermission") }}</router-link> 
                                      </li>
                                      <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorApplyType5'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.addUserPermission") }}</router-link> 
                                      </li>
                                      <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorApplyType3'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.usersystemSetting") }}</router-link> 
                                      </li>
                                     <!--  <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorApplyType6'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.transferSupervisorAccount") }}</router-link> 
                                      </li> -->
                                      
                                      <li v-if="is_SCSI">
                                        <router-link :to="'/scsiChangeSourcer'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.transferContactSourcer") }}</router-link> 
                                      </li>
                                      <li v-if="is_Sourcer">
                                        <router-link :to="'/sourcerCancelMFGCode'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.removeManufacturerCode") }}</router-link> 
                                      </li>
                                      <li v-if="is_SCSI">
                                        <router-link :to="'/scsiBatchDelete'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.batchDelete") }}</router-link> 
                                      </li>
                                      <li v-if="is_SCSI">
                                        <router-link :to="'/scsiSyncSAPVendorCode'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.scsiSyncSAPVendorCode") }}</router-link> 
                                      </li>
                                      
                                      <li v-if="is_SCSI">
                                        <router-link :to="'/flowChangeSignADList'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.flowChangeSignADList") }}</router-link> 
                                      </li>

                                      <li v-if="is_Supervisor">
                                        <router-link :to="'/supervisorUserList'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.viewDeleteUserAccount") }}</router-link> 
                                      </li>

                                      <li v-if="is_Sourcer">
                                        <router-link :to="'/sourcerUpdateShortName'"   @click="routerlinkClickHandler">{{ $t("permissionSetting.sourcerUpdateShortName") }}</router-link> 
                                      </li>
                                      <li   v-if="is_Sourcer">
                                        <router-link :to="'/sourcerApplyType7'"   @click="routerlinkClickHandler">{{ $t("report.sourcerApplyType7") }}</router-link> 
                                      </li>
                                      
                                     
                                  </ul>                              
                          </div>
                      </div>
                  </div>
                  <!--------------------------------------->
                <!--   第4個選單   -->
                <div class="accordion-item"   v-if="is_VIPAdmin || is_Sourcer || is_SCSI || is_Buyer">                     
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse4" aria-expanded="false" aria-controls="collapse4">
                            {{ $t("report.title") }}
                          </button>
                      
                      <div id="collapse4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">

                                    
                                   <!--  <li   v-if="is_VIPAdmin">
                                        <router-link :to="'/adminSearchSupervisorAndUserList'"   @click="routerlinkClickHandler">{{ $t("report.vipAccountList") }}(Admin)</router-link> 
                                      </li> -->

                                      <li   v-if="is_Sourcer">
                                        <router-link :to="'/sourcerSearchSupervisorAndUserList'"   @click="routerlinkClickHandler">{{ $t("report.vipAccountList") }}</router-link> 
                                      </li>
                                     


                                      <li   v-if="is_SCSI">
                                        <router-link :to="'/scsiSearchSupervisorAndUserList'"   @click="routerlinkClickHandler">{{ $t("report.vipAccountList") }}</router-link> 
                                      </li>
                                      <li   v-if="is_SCSI">
                                        <router-link :to="'/scsiSearchApplyFlowProcessing'"   @click="routerlinkClickHandler">{{ $t("report.scsiSearchApplyFlowProcessing") }}</router-link> 
                                      </li>
                                      




                                      <li   v-if="is_Sourcer || is_SCSI || is_Buyer">
                                        <router-link :to="'/buyerSearchSupervisorAndUserList'"  @click="routerlinkClickHandler" >{{ $t("report.vipAccountList(Single)") }}</router-link> 
                                      </li>
                                  </ul>                              
                          </div>
                      </div>
                  </div>
                  <!--------------------------------------->

                 

                  <!--   第5個選單   -->
                <div class="accordion-item"  v-if="is_VIPAdmin">                     
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse5" aria-expanded="false" aria-controls="collapse5">
                            {{ $t("administratorPermission.title") }}
                          </button>
                      
                      <div id="collapse5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">
                                      <li>
                                        <router-link :to="'/adminSystemList'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.adminSystemList") }} </router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/adminNewSystemRelease'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.newSystemOnline") }}</router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/adminUpdateType'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.adminUpdateType") }}</router-link> 
                                      </li>
                                      
                                      <li>
                                        <router-link :to="'/adminMaillogList'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.adminMaillogList") }}</router-link> 
                                      </li>
                                      
                                      <li>
                                        <router-link :to="'/adminUpdateSupervisorSAPSearchTerm'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.adminUpdateSupervisorSAPSearchTerm") }}</router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/adminApplyType8'"   @click="routerlinkClickHandler">{{ $t("administratorPermission.adminApplyType8") }}</router-link> 
                                      </li>
 
                                  </ul>                              
                          </div>
                      </div>
                  </div>
                  <!--------------------------------------->
                   <!--   第6個選單   -->
                <div class="accordion-item" >                     
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse6" aria-expanded="false" aria-controls="collapse6">
                            {{ $t("bulletinBoard.title") }}
                          </button>
                      
                      <div id="collapse6" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">
                                      <li v-if="is_VIPAdmin || is_SCSI">
                                        <router-link :to="'/userManualEditList'"   @click="routerlinkClickHandler">{{ $t("bulletinBoard.editVipUserManual") }}</router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/userManualList'"   @click="routerlinkClickHandler">{{ $t("bulletinBoard.vipUserManual") }}</router-link> 
                                      </li>
                                      <li v-if="IsSystemAdmin || is_SCSI">
                                        <router-link :to="'/bulletinEditAll'"   @click="routerlinkClickHandler">{{ $t("bulletinBoard.editAnnouncement") }}</router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/bulletinAll'"   @click="routerlinkClickHandler">{{ $t("bulletinBoard.vipView") }}</router-link> 
                                      </li>
                                      <li>
                                        <router-link :to="'/home'"   @click="routerlinkClickHandler">home</router-link> 
                                      </li>
                                  </ul>                              
                          </div>
                      </div>
                  </div>
                  <!--------------------------------------->
                  <!--   第7個選單   -->
                
                  <div class="accordion-item"   v-if="is_SCSI"> <!---accordion-item-------->                    
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse7" aria-expanded="false" aria-controls="collapse7">
                            {{ $t("aduit.title") }}
                          </button>
                      
                      <div id="collapse7" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                          <div class="accordion-body navbar-nav">                              
                                  <ul style="text-align: left;">
                                      <li  v-if="is_SCSI" >
                                        <router-link :to="'/scsiAudit'"  @click="routerlinkClickHandler" >{{ $t("aduit.scsiAduit") }}</router-link> 
                                      </li>
                                   </ul>                              
                          </div>
                      </div>
                  </div><!---accordion-item--------> 
                  <!--------------------------------------->
                  <!--------------------------------------->
                 
              </div>
          </div>
      </nav> 
</template>
  
<script>
//import variables from "@/service/variables";
export default {
    name: 'Menu',
    components: {

    },
    data() {
        return {
            toggle_menu_1:false,
            toggle_menu_2:false,
            toggle_menu_3:false,
            toggle_menu_4:false,
            toggle_menu_5:false,
            toggle_menu_6:false,
            selectedCity:null,
            items: [
        {
          label: "File",
          icon: "pi pi-fw pi-file",
          items: [
            {
              label: "New",
              icon: "pi pi-fw pi-plus",
              items: [
                {
                  label: "Bookmark",
                  icon: "pi pi-fw pi-bookmark",
                  command: (event) => {
                    this.itemClicked(event);
                  },
                },
                {
                  label: "Video",
                  icon: "pi pi-fw pi-video",
                },
              ],
            },
            {
              label: "Delete",
              icon: "pi pi-fw pi-trash",
            },
            {
              label: "Export",
              icon: "pi pi-fw pi-external-link",
            },
          ],
        },
        {
          label: "Edit",
          icon: "pi pi-fw pi-pencil",
          items: [
            {
              label: "Left",
              icon: "pi pi-fw pi-align-left",
            },
            {
              label: "Right",
              icon: "pi pi-fw pi-align-right",
            },
            {
              label: "Center",
              icon: "pi pi-fw pi-align-center",
            },
            {
              label: "Justify",
              icon: "pi pi-fw pi-align-justify",
            },
          ],
        },
        {
          label: "Users",
          icon: "pi pi-fw pi-user",
          items: [
            {
              label: "New",
              icon: "pi pi-fw pi-user-plus",
            },
            {
              label: "Delete",
              icon: "pi pi-fw pi-user-minus",
            },
            {
              label: "Search",
              icon: "pi pi-fw pi-users",
              items: [
                {
                  label: "Filter",
                  icon: "pi pi-fw pi-filter",
                  items: [
                    {
                      label: "Print",
                      icon: "pi pi-fw pi-print",
                    },
                  ],
                },
                {
                  icon: "pi pi-fw pi-bars",
                  label: "List",
                },
              ],
            },
          ],
        },
        {
          label: "Events",
          icon: "pi pi-fw pi-calendar",
          items: [
            {
              label: "Edit",
              icon: "pi pi-fw pi-pencil",
              items: [
                {
                  label: "Save",
                  icon: "pi pi-fw pi-calendar-plus",
                },
                {
                  label: "Delete",
                  icon: "pi pi-fw pi-calendar-minus",
                },
              ],
            },
            {
              label: "Archieve",
              icon: "pi pi-fw pi-calendar-times",
              items: [
                {
                  label: "Remove",
                  icon: "pi pi-fw pi-calendar-minus",
                },
              ],
            },
          ],
        },
      ],
        }
    },
    computed: {
      isLoading() {
      return this.$store.state.isLoading;
     },
    user() {
     return this.$store.state.user;
    },
    user_Id() {
     return this.$store.state.user?.Id;
    },
    user_account() {
     return this.$store.state.user?.account;
    },
    user_email() {
     return this.$store.state.user?.email;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_bg() {
     return this.$store.state.user?.BG;
    },
    user_buyerMapping() {
     return this.$store.state.user?.BuyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.SourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.VendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },
    IsSystemAdmin() {
     return this.$store.state.user?.IsSystemAdmin;
    },
    SystemAdmin() {
     return this.$store.state.user?.SystemAdmin;
    },



    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },
    flowCount() {
      return this.$store.state.flowcount;
    },
    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    cookie_token() {
     return this.$cookies.get("vip_token");
    },
    cookie_refreshToken() {
     return this.$cookies.get("vip_refreshToken");
    },
    cookie_sessionCode() {
     return this.$cookies.get("vip_sessionCode");
    },
  },
  methods: {
    itemClicked(event) {
      alert(event.item.label);
    },
    routerlinkClickHandler(){

     console.log(this.$refs['menu-btn-close']);
     this.$refs['menu-btn-close'].click();
     
    }
  },

}

</script>

